<template>
  <div class="externalLink" @click="accessWebsite">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "ExternalLink",

    props: {
      url: {
        type: String,
        required: true
      },
      target: {
        type : String,
        default: typeof cordova != "undefined" ? '_blank' : '_system'
      },
      // NO SPACE IN THE OPTIONS OR IT WONT WORK
      options: {
        type: String,
        default: 'location=no,usewkwebview=yes,toolbar=yes'
      },
    },

    methods: {
      accessWebsite() {
        if(!this.url) {
          return;
        }

        let url = this.url;
        if (this.url.indexOf("http") === -1 && this.url.indexOf("tel:") === -1 && this.url.indexOf("mailto:") === -1) {
          url = "http://" + url;
        }

        if (typeof cordova != "undefined" && typeof device != "undefined" && device.platform == "Android") {
          cordova.InAppBrowser.open(url, this.target, 'location=yes,usewkwebview=yes,toolbar=no');
        } else if (typeof cordova != "undefined"){
          cordova.InAppBrowser.open(url, this.target, this.options);
        } else {
          window.open(url, this.target);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .externalLink {
    cursor: pointer;

    &:hover:not(.btn):not(.link):not(.file) {
      text-decoration: underline;
    }
  }
</style>
